var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.77 140.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22b6a1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.38,41.91h23.29v-14.34h-19.82V11.5c-7.02,.11-13.93-.27-20.86,1.05-9.35,1.79-18.69,4.58-26.24,10.59-2.84,2.26-5.44,4.9-7.6,7.82-4.85,6.52-8.37,14.15-10.56,22.87-1.73,7.63-2.6,16.91-2.6,27.85,0,11.49,3.06,22.49,9.17,32.99,6.18,10.61,15.62,18.7,27.35,22.53,8.76,2.86,17.72,2.77,26.82,3.16h49.15v-30.67s-54.73,0-54.86,0c-6.48-.16-9.81-2.67-12.54-5.87-3.66-4.28-4.39-7.44-4.76-13.35H112.49v-30.67H40.67c1.96-11.94,9.86-17.9,23.71-17.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.65,
    y: 12.17,
    width: 21.12,
    height: 21.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.77,
    width: 19.13,
    height: 19.13
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "795.99 11.5 767.16 88.55 738.33 11.5 692.55 11.5 692.55 140.37 727.67 140.37 727.67 76.15 749.51 140.37 784.81 140.37 806.65 76.15 806.65 140.37 841.77 140.37 841.77 11.5 795.99 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M601.33,11.5V83.55c0,19.19,6.89,24.21,20.86,24.21s21.05-4.07,21.05-24.21V11.5h35.61V81.48c0,39.13-20.46,58.89-57.65,58.89s-55.47-19-55.47-59.64V11.5h35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.73,140.17c0-9.55-.01-21.2-.02-30.75l72.02,.05c4.11,0,9.47,.66,12.85-1.58,2.58-1.71,3.29-3.28,3.3-6.29,0-3.01-1.69-5.99-4.38-7.54-2.77-1.59-6.19-1.59-9.42-1.55l-34.93,.43c-7.27,.09-14.71,.15-21.57-2.15-11.21-3.77-19.46-13.75-22.47-24.76-6.03-22.09,4.56-45.43,28.04-51.86,10.36-2.84,21.32-2.06,32.1-1.94,19.81,.23,39.61-.23,59.42,0,.01,9.48,.03,21.07,.04,30.55h-73.36c-3.47,0-7.18,.07-10.02,1.97-3.62,2.43-4.73,5.08-4.29,9.3,.24,2.29,.9,4.66,2.59,6.29,2.57,2.5,6.68,2.61,10.34,2.56l29.35-.42c11.5-.16,23.68-.16,33.54,5.51,6.93,3.99,12.06,10.55,14.85,17.83,2.79,7.28,3.35,15.23,2.4,22.93-.86,7.02-3.07,14.11-7.83,19.51-4.97,5.65-12.34,8.97-19.87,10.55-7.53,1.58-15.31,1.56-23.02,1.54l-69.67-.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.79,
    y: 11.5,
    width: 34.86,
    height: 128.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "434.28 11.5 434.28 42.42 475.96 42.42 475.96 140.37 510.82 140.37 510.82 42.42 552.49 42.42 552.49 11.5 434.28 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.38,22.68c-4.83-4.22-10.85-6.96-17.18-8.65h.13c-6.53-2.22-19.28-2.54-19.28-2.54H126.04V140.37h34.86v-42.44h32.33c11.46,0,23.29,.42,32.94-5.2,12.51-7.29,17.62-24.73,17.52-38.76-.08-12.31-3.82-22.99-13.31-31.28Zm-28.49,44.11c-1.99,1.04-4.35,1.2-6.62,1.26-11.46,.32-22.94-.65-34.38,0v-25.63c11.14,0,22.29,.01,33.43,.02,2.54,0,5.2,.03,7.45,1.16,4.21,2.13,5.53,7.33,5.47,11.89-.07,4.34-1.38,9.22-5.36,11.3Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.125986b993d0613a93587cbd62f4e936.svg";
export { ForwardRef as ReactComponent };